import { COLORS } from '@/charts/utils/constants';
import { formatNumberFromLocale } from '@/utils/formatDataFromLocale/formatDataFromLocale';

interface TooltipProps {
  centerX: number;
  y: number;
  value: number | string;
  barWidth: number;
  locale: string;
}

const TOOLTIP_HEIGHT = 30;
const PADDING_X = 8;

export const Tooltip = ({ centerX, y, value, barWidth, locale }: TooltipProps) => {
  const text = formatNumberFromLocale(value, locale);

  const approxCharWidth = 7;
  const textWidth = text.length * approxCharWidth;

  const rectWidth = textWidth + PADDING_X * 2;

  const tooltipX = centerX - barWidth / 2 - rectWidth - 5;
  const tooltipY = y - TOOLTIP_HEIGHT;

  return (
    <g transform={`translate(${tooltipX}, ${tooltipY})`}>
      <rect x={0} y={0} width={rectWidth} height={TOOLTIP_HEIGHT} fill="white" stroke={COLORS.stroke} rx={2} />
      <text
        x={rectWidth / 2}
        y={TOOLTIP_HEIGHT / 2}
        textAnchor="middle"
        alignmentBaseline="middle"
        fontSize={10}
        fill={COLORS.fill}
        fontWeight="bold"
        pointerEvents="none"
      >
        {text}
      </text>
    </g>
  );
};
